// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3XjSp","tab":"ProcedureTabs_tab__34XRd"};